import AccountBillingInformation from '../../../components/hub/account/AccountBillingInformation/AccountBillingInformation';
import AccountBalance from '../components/AccountBalance';
import useBillingInformationQuery from '../../../hooks/queries/useBillingInformationQuery';
import InvoicesList from '../components/InvoicesList/InvoicesList';
import AccountPageLayout from '../../../templates/AccountPageLayout/AccountPageLayout';
import { Container } from '@cluey/cluey-components';
import useAccountDetailsQuery from '../../../hooks/queries/useAccountDetailsQuery';

const PaymentBillingPage = () => {
  const {
    data: billingInformation,
    isLoading: isLoadingBillingInformation,
    error: getBillingInformationError,
  } = useBillingInformationQuery();

  const { isLoading: isLoadingAccountDetails } = useAccountDetailsQuery();

  return (
    <AccountPageLayout loading={isLoadingBillingInformation || isLoadingAccountDetails}>
      <Container>
        <h2 className="mb-0 font-display text-2xl font-bold">Payment and billing details</h2>
        <AccountBillingInformation billingInformation={billingInformation} error={getBillingInformationError} />
        <AccountBalance billingInformation={billingInformation} error={getBillingInformationError} />
        <InvoicesList />
      </Container>
    </AccountPageLayout>
  );
};

export default PaymentBillingPage;
